import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { RouteData } from '@app/common/route-data';
import { LicenseService } from '@app/services/license.service';
import { from, Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { navigationCancelingError } from '@app/guards/navigation-canceling-error';

@Injectable({
  providedIn: 'root'
})
export class LicenseGuard implements CanActivate, CanActivateChild {

  constructor(private licenseService: LicenseService, private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.licenseService.hasUserAny365License()
      .pipe(
        mergeMap(hasUserAny365License => {
          if (hasUserAny365License) {
            return of(true);
          } else {
            const routeToShowInstead = this.router.config.find(route => (route.data as RouteData)?.onlyShowForLicensedUsers === false);
            if (routeToShowInstead) {
              return from(this.router.navigateByUrl(routeToShowInstead.path));
            } else {
              throw navigationCancelingError('unlicensed');
            }
          }
        })
      );
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(childRoute, state);
  }
}
